import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';

export const usePublishProject = () => {
  const [fetch, response] = useRequest<'' | undefined>();

  const publishProject = useCallback(
    (projectId: number) =>
      fetch(API.paths.project_confirm(projectId), 'patch', {
        data: null,
      }),
    [fetch],
  );

  return [publishProject, response] as const;
};
